import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";
import Grid from "@material-ui/core/Grid";
import Button from "components/CustomButtons/Button.jsx";
import SweetAlert from "react-bootstrap-sweetalert";

import { fetchTermCondition } from "api/notification/index";

import { pushTermcondition } from "../../api/notification";

const styles = theme => ({
  title: {
    textAlign: "center",
    flex: 1,
    fontSize: "32px",
    fontWeight: 500
  }
});

class Termcondition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      faqtext: "",
      alert: null
    };
  }

  handleChangefaqText = e => {
    this.setState({ faqtext: e.target.value });
  };

  hideAlert() {
    this.setState({
      alert: null
    });
  }

  successAlert = () => {
    this.setState({
      alert: (
        <NavLink to={"/portal"}>
          <SweetAlert
            success
            title=""
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
          >
            <font color="black">Updated</font>
          </SweetAlert>
        </NavLink>
      )
    });
  };

  handleSubmit = () => {
    pushTermcondition(this.state.faqtext)
      .then(response => {
        if (response != null) {
          console.log("berhasil");
        }
        this.successAlert();
      })
      .catch(error => {
        console.log("tidak berhasil");
        this.props.history.push("/pages/login#logout");
      });
  };

  UNSAFE_componentWillMount() {
    console.log("fecth");
    fetchTermCondition()
      .then(response => {
        if (response != null) {
          this.setState({
            faqtext: response.data.results[0].description
          });
        }
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });
  }

  render() {
    const { classes } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ justifyContent: "center" }}>
            <Typography className={classes.title}>
              Term And Condition
            </Typography>
            <CustomLinearProgress
              variant="determinate"
              color="gray"
              value={0}
              style={{ width: "40%", display: "inline-block" }}
            />
            <CustomLinearProgress
              variant="determinate"
              color="info"
              value={100}
              style={{ width: "20%", display: "inline-block" }}
            />
            <CustomLinearProgress
              variant="determinate"
              color="gray"
              value={0}
              style={{ width: "40%", display: "inline-block" }}
            />
          </div>
        </GridItem>
        <Grid item xs={12}>
          <Grid container justify="center" spacing={2}>
            <GridItem xs={10} sm={10} md={10}>
              <Card>
                <CardBody>
                  <GridItem xs={12} sm={12} md={12}>
                    <textarea
                      rows="10"
                      cols="50"
                      value={this.state.faqtext}
                      onChange={this.handleChangefaqText}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <Button color="success" round onClick={this.handleSubmit}>
                      Update
                    </Button>
                  </GridItem>
                </CardBody>
              </Card>
            </GridItem>
          </Grid>
        </Grid>
        {this.state.alert}
      </GridContainer>
    );
  }
}

export default withRouter(withStyles(styles)(Termcondition));
